// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2RJ_t","footer":"ModalUpdate_footer__saF6F"};